(function () {
  'use strict';

  var DEBUG = false;
  function log() {
    if (!DEBUG) return;
    try {
      console.log.apply(console, ['[GER ATC]'].concat([].slice.call(arguments)));
    } catch (e) {}
  }

  function getWishlistIds() {
    try {
      var saved = JSON.parse(localStorage.getItem('ger_wishlist_ids') || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlistIds(ids) {
    try {
      localStorage.setItem('ger_wishlist_ids', JSON.stringify(ids));
    } catch (e) {}
    syncHeaderBadge(ids);
    document.dispatchEvent(new CustomEvent('ger:wishlist:change', { detail: { ids: ids } }));
  }

  function syncHeaderBadge(ids) {
    var list = ids || getWishlistIds();
    document.querySelectorAll('[data-ger-wishlist-count-text]').forEach(function (el) {
      el.textContent = String(list.length);
    });
    document.querySelectorAll('[data-ger-wishlist-count]').forEach(function (el) {
      el.classList.toggle('is-empty', list.length === 0);
    });
  }

  function applyWishlistState(scope) {
    var saved = getWishlistIds();
    (scope || document).querySelectorAll('[data-ger-wishlist]').forEach(function (btn) {
      var id = String(btn.getAttribute('data-wishlist-key') || '');
      if (!id) return;
      var active = saved.indexOf(id) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
    syncHeaderBadge(saved);
  }

  function restoreListView() {
    try {
      var stored = sessionStorage.getItem('product-grid-view-desktop');
      if (stored === 'list') {
        var grid = document.querySelector('.ger-collection-page .product-grid');
        var input = document.querySelector('.ger-collection-page input[name="grid"][value="list"]');
        if (grid) grid.setAttribute('product-grid-view', 'list');
        if (input) input.checked = true;
        document.documentElement.classList.add('ger-collection-list-view');
      }
    } catch (e) {}
  }

  function bindBrandSearch(scope) {
    (scope || document).querySelectorAll('[data-ger-brand-search]').forEach(function (input) {
      if (input.getAttribute('data-ger-bound') === '1') return;
      input.setAttribute('data-ger-bound', '1');
      input.addEventListener('input', function () {
        var q = (input.value || '').trim().toLowerCase();
        var section = input.closest('.ger-filters__section--brand') || input.closest('.ger-filters__section');
        if (!section) return;
        section.querySelectorAll('[data-ger-brand-label]').forEach(function (item) {
          var label = item.getAttribute('data-ger-brand-label') || '';
          item.hidden = q !== '' && label.indexOf(q) === -1;
        });
      });
    });
  }

  function bindFilterRemoveFallback() {
    if (window.__gerFilterRemoveBound) return;
    window.__gerFilterRemoveBound = true;

    function applyRemove(removeEl) {
      var url = removeEl.getAttribute('data-url');
      if (!url) return;
      var onClick = removeEl.getAttribute('on:click') || '';
      var match = onClick.match(/form=([^&\s"]+)/);
      var formId = match ? match[1] : '';
      var formComp = formId ? document.getElementById(formId) : null;
      if (!formComp || typeof formComp.updateFiltersByURL !== 'function') {
        var section = removeEl.closest('.shopify-section') || document;
        formComp =
          section.querySelector('facets-form-component.facets__form-wrapper:not([data-filter-style])') ||
          section.querySelector('facets-form-component');
      }
      if (formComp && typeof formComp.updateFiltersByURL === 'function') {
        formComp.updateFiltersByURL(url);
        return;
      }
      window.location.assign(url);
    }

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        var removeEl = target.closest('[data-ger-filter-remove]');
        if (!removeEl || !removeEl.getAttribute('data-url')) return;
        event.preventDefault();
        event.stopPropagation();
        applyRemove(removeEl);
      },
      true
    );
  }

  function bindBrandCollectionNav() {
    if (window.__gerBrandNavBound) return;
    window.__gerBrandNavBound = true;

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        var input = target.closest('input[data-ger-brand-url]');
        var label = target.closest('[data-ger-brand-nav] label.ger-filters__brand-link');
        var url = '';
        var clearUrl = '';
        var checkbox = null;
        if (input) {
          checkbox = input;
          url = input.getAttribute('data-ger-brand-url') || '';
          clearUrl = input.getAttribute('data-ger-brand-clear-url') || '';
        } else if (label) {
          var nested = label.querySelector('input[data-ger-brand-url]');
          if (nested) {
            checkbox = nested;
            url = nested.getAttribute('data-ger-brand-url') || '';
            clearUrl = nested.getAttribute('data-ger-brand-clear-url') || '';
          }
        }
        if (!url || !checkbox) return;
        event.preventDefault();
        event.stopPropagation();
        /* Toggle: checked brand → parent collection; unchecked → brand PLP */
        if (checkbox.checked) {
          window.location.assign(clearUrl || url);
        } else {
          window.location.assign(url);
        }
      },
      true
    );

    document.addEventListener(
      'change',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        var input = target.closest('input[data-ger-brand-url]');
        if (!input) return;
        event.preventDefault();
        event.stopPropagation();
        var url = input.getAttribute('data-ger-brand-url') || '';
        var clearUrl = input.getAttribute('data-ger-brand-clear-url') || '';
        if (input.checked) {
          if (url) window.location.assign(url);
        } else if (clearUrl) {
          window.location.assign(clearUrl);
        }
      },
      true
    );
  }

  function bindWashCategoryChevron() {
    if (window.__gerWashChevronBound) return;
    window.__gerWashChevronBound = true;
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        var link = target.closest('[data-ger-wash-link]');
        if (!link) return;
        event.stopPropagation();
      },
      true
    );
  }

  function enhanceFilters() {
    document.querySelectorAll('.ger-collection-page .facets-block-wrapper--vertical').forEach(function (wrap) {
      if (wrap.id === 'filters-drawer') return;
      /* Custom filter rail already provides Categories + facets + Apply */
      if (wrap.querySelector('.ger-filters')) return;
      var target =
        wrap.querySelector('.facets--vertical') ||
        wrap.querySelector('.facets') ||
        wrap.querySelector('form') ||
        wrap;

      if (!wrap.querySelector('.ger-filters-header')) {
        var header = document.createElement('div');
        header.className = 'ger-filters-header';
        var title = document.createElement('h2');
        title.className = 'ger-filters-header__title';
        title.textContent = 'Filters';
        header.appendChild(title);

        var clearBtn =
          wrap.querySelector('.facets__clear-all-link') ||
          wrap.querySelector('.facets__clear-all') ||
          wrap.querySelector('[ref="clearButton"]');
        if (clearBtn) {
          clearBtn.textContent = 'Clear All';
          header.appendChild(clearBtn);
        } else {
          var clear = document.createElement('button');
          clear.type = 'button';
          clear.className = 'facets__clear-all-link';
          clear.textContent = 'Clear All';
          clear.addEventListener('click', function () {
            var form = wrap.querySelector('form');
            if (!form) return;
            form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (el) {
              el.checked = false;
            });
            if (typeof form.requestSubmit === 'function') form.requestSubmit();
            else form.submit();
          });
          header.appendChild(clear);
        }
        target.insertBefore(header, target.firstChild);
      }

      if (wrap.querySelector('.ger-apply-filters')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ger-apply-filters';
      btn.textContent = 'Apply Filters';
      btn.addEventListener('click', function () {
        var form = wrap.querySelector('form') || document.querySelector('.ger-collection-page form.facets');
        if (form) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
          return;
        }
        var drawerClose = document.querySelector('.facets-drawer [ref="closeButton"], .facets-drawer .drawer__close');
        if (drawerClose) drawerClose.click();
        window.scrollTo({ top: wrap.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
      });
      target.appendChild(btn);
    });
  }

  function getVariantId(form) {
    var input = form.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  function getQuantity(form) {
    var input = form.querySelector('[name="quantity"], .quantity__input, quantity-selector input');
    var qty = input ? Number(input.value || 1) : 1;
    return Math.max(1, qty);
  }

  function setAtcState(button, state, message) {
    if (!button) return;
    button.classList.remove('is-ger-loading', 'is-ger-success', 'is-ger-error');
    // Do NOT disable here before Horizon submit — product-form aborts when the ATC button is disabled.
    if (state !== 'loading') {
      button.disabled = false;
    }
    button.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');

    var label = button.querySelector('[data-ger-atc-label]');
    if (!label) {
      label = button.querySelector('.ger-atc-label');
    }
    if (!label) return;

    if (state === 'loading') {
      button.classList.add('is-ger-loading');
      label.textContent = 'Adding...';
    } else if (state === 'success') {
      button.classList.add('is-ger-success');
      label.textContent = '✓ Added to cart';
      window.setTimeout(function () {
        button.classList.remove('is-ger-success');
        label.textContent = 'Add to Cart';
      }, 1600);
    } else if (state === 'error') {
      button.classList.add('is-ger-error');
      label.textContent = 'Add to Cart';
      showFormError(button, message || 'Could not add to cart');
    } else {
      label.textContent = 'Add to Cart';
    }
  }

  function showFormError(button, message) {
    var form = button.closest('form') || button.closest('product-form-component');
    if (!form) {
      alert(message);
      return;
    }
    var errorEl = form.querySelector('[ref="addToCartTextError"], .product-form-text__error');
    if (!errorEl) {
      alert(message);
      return;
    }
    errorEl.classList.remove('hidden');
    var textNode = null;
    errorEl.childNodes.forEach(function (node) {
      if (node.nodeType === 3 && node.textContent.trim()) textNode = node;
    });
    if (textNode) textNode.textContent = message;
    else errorEl.appendChild(document.createTextNode(message));
    window.setTimeout(function () {
      errorEl.classList.add('hidden');
    }, 6000);
  }

  async function addToCartAndCheckout(form) {
    var id = getVariantId(form);
    var quantity = getQuantity(form);
    log('Buy it now clicked', 'Variant ID:', id, 'Quantity:', quantity);
    if (!id) {
      alert('Missing product variant');
      return;
    }
    try {
      var res = await fetch(
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') +
          'cart/add.js',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity }] }),
        }
      );
      log('Buy it now response', res.status);
      if (!res.ok) {
        var errBody = null;
        try {
          errBody = await res.json();
        } catch (e) {}
        throw new Error((errBody && (errBody.description || errBody.message)) || 'Unable to add to bag');
      }
      window.location.href = '/checkout';
    } catch (err) {
      alert(err.message || 'Could not continue to checkout');
    }
  }

  function ensureAtcLabel(button) {
    if (!button || button.querySelector('[data-ger-atc-label], .ger-atc-label')) return;
    // Softly normalize visible text without destroying Horizon added-state markup
    var added = button.querySelector('.add-to-cart__added');
    var label = document.createElement('span');
    label.className = 'ger-atc-label';
    label.setAttribute('data-ger-atc-label', '');
    label.textContent = 'Add to Cart';

    // Remove loose text nodes that say "Add to cart"
    Array.prototype.slice.call(button.childNodes).forEach(function (node) {
      if (node.nodeType === 3 && /add to cart/i.test(node.textContent || '')) {
        node.textContent = '';
      }
    });
    if (added) button.insertBefore(label, added);
    else button.appendChild(label);
  }

  function enhanceBuyButtons(scope) {
    (scope || document).querySelectorAll('.ger-collection-page .buy-buttons-block').forEach(function (block) {
      var form =
        block.tagName === 'FORM'
          ? block
          : block.querySelector(
              'form[data-type="add-to-cart-form"], form.shopify-product-form, product-form-component form, form'
            );
      if (!form) return;

      var accelerated = block.querySelector(
        '.shopify-payment-button, .accelerated-checkout-block, shopify-accelerated-checkout'
      );
      if (accelerated) accelerated.style.display = 'none';

      var atc = block.querySelector('.add-to-cart-button, button[type="submit"][name="add"]');
      if (atc) ensureAtcLabel(atc);
    });
  }

  function bindAtcLoadingFeedback() {
    if (window.__gerAtcLoadingBound) return;
    window.__gerAtcLoadingBound = true;

    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target && event.target.closest
          ? event.target.closest('.ger-collection-page .buy-buttons-block .add-to-cart-button')
          : null;
        if (!btn) return;
        var form = btn.closest('form');
        var variantId = form ? getVariantId(form) : null;
        var quantity = form ? getQuantity(form) : 1;
        log('Add to cart clicked');
        log('Variant ID:', variantId);
        log('Quantity:', quantity);
        ensureAtcLabel(btn);
        setAtcState(btn, 'loading');
        btn.dataset.gerPending = '1';
        /* Safety reset if cart events never fire */
        clearTimeout(btn.__gerAtcTimer);
        btn.__gerAtcTimer = setTimeout(function () {
          if (btn.dataset.gerPending === '1') {
            btn.dataset.gerPending = '';
            setAtcState(btn, 'idle');
          }
        }, 8000);
      },
      true
    );

    function clearPending(state, message) {
      document.querySelectorAll('.ger-collection-page .add-to-cart-button[data-ger-pending="1"]').forEach(function (btn) {
        clearTimeout(btn.__gerAtcTimer);
        btn.dataset.gerPending = '';
        setAtcState(btn, state, message);
      });
    }

    /* Horizon cart events only — never patch window.fetch (avoids analytics noise in console) */
    document.addEventListener('cart:update', function () {
      clearPending('success');
    });
    document.addEventListener('cart:error', function () {
      clearPending('error');
    });
  }

  if (!window.__gerWishlistDelegated) {
    window.__gerWishlistDelegated = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ger-wishlist]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = String(btn.getAttribute('data-wishlist-key') || '');
      if (!id) return;
      var saved = getWishlistIds();
      var i = saved.indexOf(id);
      if (i === -1) saved.push(id);
      else saved.splice(i, 1);
      setWishlistIds(saved);
      applyWishlistState(document);
    });
  }

  function formatGerCountLabel(productsCount, colorsCount) {
    var productsLabel = productsCount === 1 ? '1 Product' : productsCount + ' Products';
    var colorsLabel = colorsCount === 1 ? '1 Color' : colorsCount + ' Colors';
    return productsLabel + ' · ' + colorsLabel;
  }

  var GER_ITEMS_PER_PAGE = 30;
  var GER_PAGE_PARAM = 'ger_page';
  var gerVisualPageState = {
    fingerprint: '',
    bound: false
  };

  function getGerItemsPerPage() {
    var wrap = document.querySelector('.collection-wrapper[data-ger-items-per-page]');
    var n = wrap ? parseInt(wrap.getAttribute('data-ger-items-per-page') || '30', 10) : GER_ITEMS_PER_PAGE;
    return n > 0 ? n : GER_ITEMS_PER_PAGE;
  }

  function getFilterFingerprint() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete(GER_PAGE_PARAM);
      return url.pathname + '?' + url.searchParams.toString();
    } catch (e) {
      return window.location.pathname + window.location.search;
    }
  }

  function getGerPageFromUrl() {
    try {
      var p = parseInt(new URL(window.location.href).searchParams.get(GER_PAGE_PARAM) || '1', 10);
      return isNaN(p) || p < 1 ? 1 : p;
    } catch (e) {
      return 1;
    }
  }

  function setGerPageInUrl(page, replace) {
    try {
      var url = new URL(window.location.href);
      if (page <= 1) url.searchParams.delete(GER_PAGE_PARAM);
      else url.searchParams.set(GER_PAGE_PARAM, String(page));
      if (replace) history.replaceState({ gerPage: page }, '', url.toString());
      else history.pushState({ gerPage: page }, '', url.toString());
    } catch (e) {}
  }

  function getVisualCards(grid) {
    var variantCards = grid.querySelectorAll('.ger-variant-card-item');
    if (variantCards.length) return Array.prototype.slice.call(variantCards);
    if (grid.getAttribute('data-ger-visual-pagination-grid') === 'true') {
      return Array.prototype.slice.call(grid.querySelectorAll('.product-grid__item'));
    }
    return [];
  }

  function ensureVisualPaginationNav(grid) {
    var parent = grid.parentElement;
    if (!parent) return null;
    var nav = parent.querySelector('[data-ger-visual-pagination]');
    if (!nav) {
      nav = document.createElement('nav');
      nav.className = 'ger-visual-pagination';
      nav.setAttribute('data-ger-visual-pagination', '');
      nav.setAttribute('aria-label', 'Collection pagination');
      parent.appendChild(nav);
    }
    return nav;
  }

  function buildVisualPaginationHtml(current, totalPages) {
    var html = '';
    var prevDisabled = current <= 1;
    var nextDisabled = current >= totalPages;

    html +=
      '<button type="button" class="ger-visual-pagination__btn ger-visual-pagination__btn--prev"' +
      (prevDisabled ? ' disabled' : '') +
      ' data-ger-page="' +
      (current - 1) +
      '" aria-label="Previous page">‹ Previous</button>';

    html += '<div class="ger-visual-pagination__pages">';
    for (var i = 1; i <= totalPages; i++) {
      var active = i === current;
      html +=
        '<button type="button" class="ger-visual-pagination__page' +
        (active ? ' is-active' : '') +
        '" data-ger-page="' +
        i +
        '" aria-label="Go to page ' +
        i +
        '"' +
        (active ? ' aria-current="page"' : '') +
        '>' +
        i +
        '</button>';
    }
    html += '</div>';

    html +=
      '<button type="button" class="ger-visual-pagination__btn ger-visual-pagination__btn--next"' +
      (nextDisabled ? ' disabled' : '') +
      ' data-ger-page="' +
      (current + 1) +
      '" aria-label="Next page">Next ›</button>';

    return html;
  }

  function applyVisualPagination(options) {
    options = options || {};
    var pageRoot = document.querySelector('.ger-collection-page');
    if (!pageRoot) return;

    var grid = pageRoot.querySelector('.product-grid[data-ger-visual-pagination-grid="true"]');
    if (!grid) return;

    var cards = getVisualCards(grid);
    var nav = ensureVisualPaginationNav(grid);
    var fingerprint = getFilterFingerprint();

    if (!cards.length) {
      if (nav) {
        nav.hidden = true;
        nav.innerHTML = '';
      }
      gerVisualPageState.fingerprint = fingerprint;
      return;
    }

    var perPage = getGerItemsPerPage();
    var totalPages = Math.ceil(cards.length / perPage) || 1;
    var filterChanged = gerVisualPageState.fingerprint && gerVisualPageState.fingerprint !== fingerprint;
    var current;

    if (options.reset || filterChanged) {
      current = 1;
    } else if (options.page) {
      current = options.page;
    } else {
      current = getGerPageFromUrl();
    }

    if (current > totalPages) current = totalPages;
    if (current < 1) current = 1;

    var end = current * perPage;

    cards.forEach(function (card, index) {
      var show = index < end;
      card.hidden = !show;
      card.classList.toggle('ger-visual-page-hidden', !show);
    });

    gerVisualPageState.current = current;
    gerVisualPageState.totalPages = totalPages;
    gerVisualPageState.fingerprint = fingerprint;

    if (!nav) return;

    if (current >= totalPages) {
      nav.hidden = true;
      nav.innerHTML = '';
      if (gerVisualPageState.observer) gerVisualPageState.observer.disconnect();
      if (totalPages <= 1 && options.syncUrl !== false) setGerPageInUrl(1, true);
      return;
    }

    nav.hidden = false;
    nav.innerHTML =
      '<span class="ger-load-more__spinner ger-visual-pagination__loader" aria-hidden="true"></span>';
    observeVisualPaginationSentinel(nav);
  }

  function observeVisualPaginationSentinel(nav) {
    if (!('IntersectionObserver' in window)) {
      nav.innerHTML = buildVisualPaginationHtml(gerVisualPageState.current, gerVisualPageState.totalPages);
      return;
    }
    if (!gerVisualPageState.observer) {
      gerVisualPageState.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            if (gerVisualPageState.current >= gerVisualPageState.totalPages) return;
            applyVisualPagination({ page: gerVisualPageState.current + 1, syncUrl: false });
          });
        },
        { rootMargin: '400px 0px' }
      );
    }
    gerVisualPageState.observer.disconnect();
    gerVisualPageState.observer.observe(nav);
  }

  function bindVisualPagination() {
    if (gerVisualPageState.bound) return;
    gerVisualPageState.bound = true;

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-ger-visual-pagination] [data-ger-page]');
      if (!btn || btn.disabled) return;
      event.preventDefault();
      var page = parseInt(btn.getAttribute('data-ger-page') || '1', 10);
      if (isNaN(page) || page < 1) return;
      applyVisualPagination({ page: page, replaceUrl: false, scrollIntoView: true, syncUrl: true });
    });

    window.addEventListener('popstate', function () {
      applyVisualPagination({ page: getGerPageFromUrl(), replaceUrl: true, syncUrl: false });
    });
  }

  function updateVariantCardCount() {
    var page = document.querySelector('.ger-collection-page');
    if (!page) return;

    var grid = page.querySelector('.product-grid');
    var wrappers = page.querySelectorAll('.products-count-wrapper [data-ger-count-label], .products-count-wrapper [role="status"]');
    if (!wrappers.length) return;

    var wrapMeta = page.querySelector('.collection-wrapper[data-ger-products-count]');
    var shopifyProducts = wrapMeta
      ? parseInt(wrapMeta.getAttribute('data-ger-products-count') || '0', 10)
      : 0;
    var hasExplodedAttr = wrapMeta && wrapMeta.getAttribute('data-ger-has-exploded-colors') === 'true';

    if (!grid) return;

    var cards = grid.querySelectorAll('.product-grid__item');
    var variantCards = grid.querySelectorAll('.ger-variant-card-item');
    var hasVariantCards = variantCards.length > 0 || hasExplodedAttr;

    if (!hasVariantCards) return;

    var productIds = {};
    cards.forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      if (id) productIds[id] = true;
    });
    var uniqueProducts = Object.keys(productIds).length;
    var productsCount = shopifyProducts > 0 ? shopifyProducts : uniqueProducts;
    var colorsCount = variantCards.length > 0 ? variantCards.length : cards.length;
    var label = formatGerCountLabel(productsCount, colorsCount);

    wrappers.forEach(function (el) {
      el.textContent = label;
      el.setAttribute('data-ger-products-count', String(productsCount));
      el.setAttribute('data-ger-color-count', String(colorsCount));
      el.setAttribute('data-ger-has-exploded-colors', 'true');
    });

    if (wrapMeta) {
      wrapMeta.setAttribute('data-ger-color-count', String(colorsCount));
      wrapMeta.setAttribute('data-ger-has-exploded-colors', 'true');
    }
  }

  function bindPlpSwatches(scope) {
    (scope || document).querySelectorAll('[data-ger-plp-card]').forEach(function (card) {
      if (card.dataset.gerPlpReady === 'true') return;
      card.dataset.gerPlpReady = 'true';

      card.addEventListener('click', function (event) {
        var swatch = event.target.closest('[data-ger-plp-swatch]');
        if (!swatch || !card.contains(swatch)) return;
        event.preventDefault();

        card.querySelectorAll('[data-ger-plp-swatch]').forEach(function (el) {
          el.classList.toggle('is-active', el === swatch);
        });

        var imageUrl = swatch.getAttribute('data-image-url');
        var img = card.querySelector('.ger-variant-card__img--primary') || card.querySelector('.ger-variant-card__img:not(.ger-variant-card__img--secondary)');
        if (imageUrl && img) {
          img.setAttribute('src', imageUrl);
          img.removeAttribute('srcset');
        }

        var variantId = swatch.getAttribute('data-variant-id');
        var variantInput = card.querySelector('[data-ger-plp-variant-input]');
        if (variantId && variantInput) variantInput.value = variantId;

        var variantUrl = swatch.getAttribute('data-variant-url');
        if (variantUrl) {
          card.querySelectorAll('a.ger-variant-card__media-link, .ger-variant-card__title a').forEach(function (link) {
            link.setAttribute('href', variantUrl);
          });
        }
      });
    });
  }

  function bindFilterScrollPreserve() {
    if (window.__gerFilterScrollBound) return;
    window.__gerFilterScrollBound = true;

    var SCROLL_MQ = window.matchMedia('(min-width: 990px)');
    var HEADER_OFFSET = 88;
    var savedTop = null;
    var pendingFocus = false;
    var unlockTimer = 0;
    var focusTimer = 0;

    function getScrollContainer() {
      if (SCROLL_MQ.matches) {
        return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
      }
      return document.scrollingElement || document.documentElement;
    }

    function getScrollTop() {
      return getScrollContainer().scrollTop || 0;
    }

    function setScrollTop(top, behavior) {
      var container = getScrollContainer();
      try {
        container.scrollTo({ top: Math.max(0, top), behavior: behavior || 'instant' });
      } catch (e) {
        container.scrollTop = Math.max(0, top);
      }
    }

    function getResultsAnchor() {
      var page = document.querySelector('.ger-collection-page');
      if (!page) return null;
      return (
        page.querySelector('.ger-collection-toolbar') ||
        page.querySelector('.products-count-wrapper') ||
        page.querySelector('.product-grid') ||
        page.querySelector('results-list') ||
        page
      );
    }

    function isFilterDrawerOpen() {
      var drawer = document.getElementById('filters-drawer');
      if (!drawer) return false;
      if (drawer.hasAttribute('open')) return true;
      var dialog = drawer.querySelector('dialog');
      return !!(dialog && dialog.open);
    }

    function clearPending() {
      pendingFocus = false;
      savedTop = null;
      clearTimeout(unlockTimer);
      clearTimeout(focusTimer);
    }

    function beginFilterScrollGuard() {
      pendingFocus = true;
      savedTop = getScrollTop();
      clearTimeout(unlockTimer);
      /* Hard unlock — never leave scroll trapped if an event is missed */
      unlockTimer = setTimeout(function () {
        if (!pendingFocus) return;
        restoreOrFocusResults();
      }, 1800);
    }

    function restoreOrFocusResults() {
      if (isFilterDrawerOpen()) {
        clearTimeout(focusTimer);
        focusTimer = setTimeout(restoreOrFocusResults, 120);
        return;
      }

      var anchor = getResultsAnchor();
      var keep = savedTop;
      clearPending();

      if (anchor) {
        var rect = anchor.getBoundingClientRect();
        var viewportH = window.innerHeight || document.documentElement.clientHeight || 800;
        /* Jumped near page top after morph — bring user back to results */
        if (getScrollTop() < 80 || rect.top < 0 || rect.top > viewportH * 0.55) {
          var container = getScrollContainer();
          var containerTop =
            container === document.documentElement ||
            container === document.body ||
            container === document.scrollingElement
              ? 0
              : container.getBoundingClientRect().top;
          var target = getScrollTop() + rect.top - containerTop - HEADER_OFFSET;
          setScrollTop(target, 'smooth');
          return;
        }
      }

      /* Otherwise restore the pre-filter position once (no continuous lock) */
      if (keep != null && Math.abs(getScrollTop() - keep) > 40) {
        setScrollTop(keep, 'instant');
      }
    }

    function afterFilterRender(promise) {
      if (!pendingFocus) return;
      var token = Date.now();
      pendingFocus = token;

      var done = function () {
        if (pendingFocus !== token) return;
        requestAnimationFrame(function () {
          setTimeout(function () {
            if (pendingFocus !== token) return;
            applyVisualPagination({ reset: true, replaceUrl: true, syncUrl: true });
            updateVariantCardCount();
            restoreOrFocusResults();
          }, 60);
        });
      };

      if (promise && typeof promise.then === 'function') {
        promise.then(done).catch(done);
      } else {
        done();
      }
    }

    function isCollectionFilterTarget(target) {
      if (!(target instanceof Element)) return false;
      if (!target.closest('.ger-collection-page, #filters-drawer, facets-form-component')) return false;
      if (target.closest('[data-ger-brand-url], [data-ger-brand-nav]')) return false;
      if (target.closest('[data-ger-visual-pagination]')) return false;
      return !!(
        target.closest(
          'facet-inputs-component, price-facet-component, facet-remove-component, sorting-filter-component, .ger-filters__section, [data-ger-filter-remove]'
        ) ||
        target.matches('input[name^="filter."], input[form*="Facet"], select[name="sort_by"]')
      );
    }

    document.addEventListener(
      'change',
      function (event) {
        if (!isCollectionFilterTarget(event.target)) return;
        beginFilterScrollGuard();
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest('[data-ger-filter-remove], .ger-filters__clear-all, .ger-active-filters__clear, .ger-active-filters__chip')) {
          beginFilterScrollGuard();
        }
      },
      true
    );

    document.addEventListener(
      'collection:update',
      function (event) {
        if (!document.querySelector('.ger-collection-page')) return;
        if (!pendingFocus) beginFilterScrollGuard();
        var promise =
          (event && event.promise) ||
          (event && event.detail && event.detail.promise) ||
          null;
        afterFilterRender(promise);
      },
      true
    );

    document.addEventListener(
      'search:update',
      function (event) {
        if (!document.querySelector('.ger-collection-page')) return;
        if (!pendingFocus) beginFilterScrollGuard();
        var promise =
          (event && event.promise) ||
          (event && event.detail && event.detail.promise) ||
          null;
        afterFilterRender(promise);
      },
      true
    );

    document.addEventListener(
      'close',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        if (target.id !== 'filters-drawer' && !target.closest('#filters-drawer')) return;
        if (!pendingFocus) return;
        setTimeout(restoreOrFocusResults, 80);
      },
      true
    );
  }

  function boot() {
    applyWishlistState(document);
    restoreListView();
    enhanceFilters();
    bindBrandSearch(document);
    bindBrandCollectionNav();
    bindWashCategoryChevron();
    bindFilterRemoveFallback();
    bindFilterScrollPreserve();
    enhanceBuyButtons(document);
    bindAtcLoadingFeedback();
    bindVisualPagination();
    updateVariantCardCount();
    applyVisualPagination({ replaceUrl: true });
    bindPlpSwatches(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.querySelector('.ger-collection-page .product-grid');
    if (grid) {
      var debounceTimer = null;
      new MutationObserver(function () {
        applyWishlistState(document);
        enhanceBuyButtons(document);
        bindPlpSwatches(document);
        updateVariantCardCount();
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          applyVisualPagination({ replaceUrl: true });
        }, 40);
      }).observe(grid, { childList: true, subtree: true });
    }
  });
})();
